$(function () {

	$('#CallSchool').click(function () {
		if (!user) {
			$('#loginModal').modal('show', {backdrop: 'static', keyboard: false});
		} else {
			var phoneNum = $('#CallSchool').attr('data-phone');
			$('#CallSchool').attr('href', 'tel:' + phoneNum);
		}
	});

	const detailNav = $('#detailNav');
	var detailNavScroll = detailNav.offset().top - detailNav.height();
	$(document).scroll(function () {
		if ($(document).scrollTop() > detailNavScroll) {
			detailNav.css('position', 'fixed');
			detailNav.css('top', '50px');
			detailNav.css('right', '0');
			detailNav.css('width', '100%');
			detailNav.css('border-radius', '0');
			detailNav.css('z-index', '99');
			$('#headerBottom').hide();
			if (window.matchMedia('(max-width: 992px)').matches) {
				detailNav.css('top', '95px');
			}
		} else {
			detailNav.css('position', '');
			detailNav.css('top', '');
			detailNav.css('right', '');
			detailNav.css('width', '');
			detailNav.css('border-radius', '');
			detailNav.css('z-index', '');
			$('#headerBottom').show();
		}
	});

	$("a[href^='#']:not([href='#'])").click(function (e) {
		e.preventDefault();
		let positionScroll;
		if ($(document).scrollTop() > detailNavScroll) {
			positionScroll = $($(this).attr("href")).offset().top - ($('#headerBottom').height() + $('header').height() + 20);
		} else {
			positionScroll = $($(this).attr("href")).offset().top - ($('#headerBottom').height() + $('header').height() + 100);
		}
		if (window.matchMedia('(max-width: 992px)').matches) {
			positionScroll -= 40;
		}
		$("body, html").animate({scrollTop: positionScroll}); /* speed */
	});

	// hiding navs that are not included in the page.
	let navs = $('.checkNav');
	let tabs = $('.tabs-list-elem');
	for (let i = 0; i < navs.length; i++) {
		let link = $(tabs[i]).attr('href');
		if ($(link).length == 0) {
			$(navs[i]).hide();
		}
	}

// navigation functionality
	$('#nav-data').on('click', 'li', function () {
		$('#nav-data li.active').removeClass('active');
		$(this).addClass('active');
	});

	$('.expert-comment-link').on('click', function(e){
		e.preventDefault();
		let readMoreButton = $(this);
		let schoolId = readMoreButton.attr('data-id');
		let moreText = readMoreButton.prev().prev();
		let readMoreDots = readMoreButton.prev();

		if (moreText.hasClass('d-none')) {
			readMoreDots.addClass('d-none');
			readMoreButton.text(" Read Less");
			moreText.removeClass('d-none');
		} else {
			readMoreDots.removeClass('d-none');
			readMoreButton.text(" Read more");
			moreText.addClass('d-none');
		}
	});

});
